'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _sortArrow = require('./sort-arrow');

var _sortArrow2 = _interopRequireDefault(_sortArrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportTableHeader = function ReportTableHeader(_ref) {
  var onSortChanged = _ref.onSortChanged,
      sort = _ref.sort;
  return _react2.default.createElement(
    _semanticUiReact.Table.Header,
    null,
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('name');
        }
      },
      'influencer ',
      _react2.default.createElement(_sortArrow2.default, (0, _extends3.default)({ targetField: 'name' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('trackedAssetsStats.totalAssets');
        }
      },
      'assets ',
      _react2.default.createElement(_sortArrow2.default, (0, _extends3.default)({ targetField: 'trackedAssetsStats.totalAssets' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('derivedFee');
        },
        textAlign: 'center'
      },
      'influencer ',
      _react2.default.createElement('br', null),
      'fee ',
      _react2.default.createElement(_sortArrow2.default, (0, _extends3.default)({ twoRowsMode: true, targetField: 'derivedFee' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.reach');
        },
        textAlign: 'center'
      },
      'total ',
      _react2.default.createElement('br', null),
      'reach ',
      _react2.default.createElement(_sortArrow2.default, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.reach' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.impressions');
        },
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'total ',
          _react2.default.createElement('br', null),
          'imps',
          _react2.default.createElement(_sortArrow2.default, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.impressions' }, sort))
        ),
        content: 'total impressions'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.videoViews');
        },
        textAlign: 'center'
      },
      'video ',
      _react2.default.createElement('br', null),
      'views ',
      _react2.default.createElement(_sortArrow2.default, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.videoViews' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.engagements');
        },
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'total ',
          _react2.default.createElement('br', null),
          'engs ',
          _react2.default.createElement(_sortArrow2.default, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.engagements' }, sort))
        ),
        content: _react2.default.createElement(
          'span',
          null,
          'total engagements:',
          _react2.default.createElement('br', null),
          ' likes + comments'
        )
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        textAlign: 'center',
        style: { color: 'red', opacity: 0.5 }
      },
      'GA',
      _react2.default.createElement('br', null),
      'SESSIONS'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        textAlign: 'center',
        style: { color: 'red', opacity: 0.5 }
      },
      'GA',
      _react2.default.createElement('br', null),
      'HITS'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        textAlign: 'center',
        style: { color: 'red', opacity: 0.5 }
      },
      'GA',
      _react2.default.createElement('br', null),
      'BOUNCES'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        textAlign: 'center',
        style: { color: 'red', opacity: 0.5 }
      },
      'GA',
      _react2.default.createElement('br', null),
      'GOALS'
    )
  );
};

ReportTableHeader.propTypes = {
  onSortChanged: _propTypes2.default.func.isRequired
};

exports.default = ReportTableHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/google-analytics-report/report-table-header.js
// module id = 2182
// module chunks = 1